<script>
    import _ from 'lodash'
    import * as types from '../store/types'

    export default {
        props: {
            sid: {
                type: String,
                required: false,
                default: () => _.uuid()
            },
            include: {
                type: Array,
                default () {
                    return []
                }
            }
        },
        data () {
            return {
                is_loading: false
            }
        },
        computed: {
            error () {
                return this.$store.getters[types.errors.getters.item](this.sid)
            },
            item () {
                return this.$store.getters[types.bank_cards.getters.item](this.sid)
            }
        },
        destroyed () {
            this.forget()
        },
        methods: {
            store (data = {}, card) {
                this.is_loading = true

                this.$store.dispatch(types.errors.actions.forget, { sid: this.sid })

                this.$store.dispatch(types.bank_cards.actions.store, {
                    sid: this.sid,
                    data
                })
                    .then(({ meta }) => {
                        this.$stripe.confirmCardPayment(meta.payment_intent.client_secret, {
                            payment_method: {
                                card,
                                billing_details: {
                                    name: data.name,
                                    address: {
                                        line1: data.address.street,
                                        line2: data.address.locality,
                                        city: data.address.town,
                                        state: data.address.county,
                                        postal_code: data.postcode
                                    }
                                }
                            },
                            setup_future_usage: 'off_session'
                        })
                            .then(result => {
                                this.is_loading = false

                                if (result.error) {
                                    this.$validator.set({
                                        message: 'Whoops!',
                                        detail: 'Please check the form for errors.',
                                        errors: {
                                            bank_card: [result.error.message]
                                        }
                                    }, this.sid)

                                    this.$error.emit(this, result.error)
                                } else {
                                    this.$emit('success', this.item)

                                    return this.item
                                }
                            })
                            .catch(error => {
                                this.is_loading = false

                                this.$error.emit(this, error)
                            })
                    })
                    .catch(error => {
                        this.is_loading = false

                        this.$error.emit(this, error)
                    })
            },
            forget () {
                this.$store.dispatch(types.errors.actions.forget, { sid: this.sid })
                this.$store.dispatch(types.bank_cards.actions.forget, { sid: this.sid })
            }
        },
        render () {
            return this.$scopedSlots.default({
                sid: this.sid,
                is_loading: this.is_loading,
                data: _.get(this.item, 'data'),
                meta: _.get(this.item, 'meta'),
                error: this.error,
                store: this.store,
                forget: this.forget
            })
        }
    }
</script>
